import { billingRoutes, orgRoutes } from '@/routes/org-routes.const'

import type { Notification } from './notification.interface'

export const mockNotificationList: Notification[] = [
  {
    id: 'notif-1',
    type: 'agent_reply',
    isRead: false,
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    agentName: 'SAAGA Agent',
    chatName: 'Project Discussion',
    messagePreview: 'I have analyzed your request and prepared a detailed response.',
    actionUrl: '/chat/project-discussion',
  },
  {
    id: 'notif-2',
    type: 'human_message',
    isRead: false,
    timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    userName: 'John Doe',
    userAvatarUrl: 'https://i.pravatar.cc/150?u=john',
    chatName: 'Team Chat',
    messagePreview: 'Hey team, can we discuss the new feature requirements?',
    actionUrl: '/chat/team-chat',
  },
  {
    id: 'notif-3',
    type: 'system_balance_low',
    isRead: false,
    timestamp: new Date(Date.now() - 60 * 60 * 1000).toISOString(),
    title: 'Balance Low',
    message: 'Your account balance is running low. Please add funds to continue.',
    actionUrl: `/${orgRoutes.settings}/${billingRoutes.billing}`,
  },
  {
    id: 'notif-4',
    type: 'human_note',
    isRead: true,
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    userName: 'Jane Smith',
    userAvatarUrl: 'https://i.pravatar.cc/150?u=jane',
    chatName: 'Design Review',
    messagePreview: 'Important: Remember to update the color scheme before the demo.',
    actionUrl: '/chat/design-review',
  },
  {
    id: 'notif-5',
    type: 'agent_reply',
    isRead: true,
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    agentName: 'Code Assistant',
    chatName: 'Bug Fix',
    messagePreview: 'The issue has been resolved. The null check was missing.',
    actionUrl: '/chat/bug-fix',
  },
]
